import { render, staticRenderFns } from "./wysiwyg-cmp.vue?vue&type=template&id=56c43bfc&scoped=true"
import script from "./wysiwyg-cmp.vue?vue&type=script&lang=js"
export * from "./wysiwyg-cmp.vue?vue&type=script&lang=js"
import style0 from "./wysiwyg-cmp.vue?vue&type=style&index=0&id=56c43bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c43bfc",
  null
  
)

export default component.exports